import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease }}
  >
    {children}
  </motion.div>
);

const lineVariants = {
  hidden: { y: "105%" },
  show: (d) => ({ y: "0%", transition: { duration: 1.1, delay: d, ease } }),
};

export const MaskLines = ({ lines, className = "", delay = 0, inView = false }) => {
  const trigger = inView
    ? { whileInView: "show", viewport: { once: true, amount: 0.1 } }
    : { animate: "show" };
  return (
    <motion.span className={`block ${className}`} initial="hidden" {...trigger}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.06em]">
          <motion.span className="block" variants={lineVariants} custom={delay + i * 0.12}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const Eyebrow = ({ children }) => (
  <p className="mb-5 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-blue-400">
    <span className="h-px w-8 bg-blue-600" />
    {children}
  </p>
);
